const parseHex = (hex: string): [number, number, number] => {
  const clean = hex.replace('#', '');
  const full =
    clean.length === 3
      ? clean
          .split('')
          .map((character) => character + character)
          .join('')
      : clean;
  return [
    parseInt(full.slice(0, 2), 16),
    parseInt(full.slice(2, 4), 16),
    parseInt(full.slice(4, 6), 16),
  ];
};

/**
 * Blend a hex colour toward white. Unlike lowering alpha, this stays fully
 * opaque so bars can't be seen through (e.g. over day/night background bands).
 */
const mixWithWhite = (hex: string, whiteWeight: number): string => {
  const [red, green, blue] = parseHex(hex);
  const mix = (channel: number) =>
    Math.round(channel + (255 - channel) * whiteWeight);
  return `rgb(${mix(red)}, ${mix(green)}, ${mix(blue)})`;
};

import { WEATHER_CHART_BAR_STYLE } from '../charts/chartDefaults';

export const buildBarChartColors = (
  color: string,
  fillColor: string,
  inactiveWhiteMix = WEATHER_CHART_BAR_STYLE.inactiveWhiteMix,
) => ({
  active: { top: color, bottom: fillColor },
  inactive: {
    top: mixWithWhite(color, inactiveWhiteMix),
    bottom: mixWithWhite(fillColor, inactiveWhiteMix),
  },
});
